import { type TDS_LOCALES, TDS_DEFAULT_LOCALE } from '../../tds'

/**
 * This is a mapping of the locales that we support in the app.
 * It is used to ensure that the locale is one of the supported ones.
 * Every IPP locale should be a supported TDS locale.
 */
export type IPP_SUPPORTED_LOCALE = TDS_LOCALES

export const IPP_DEFAULT_LOCALE = TDS_DEFAULT_LOCALE

export const IPP_NA_LOCALES = ['en-US'] as const
export const IPP_EU_LOCALES = ['es-ES', 'fr-FR'] as const

/**
 * All supported IPP locales, composed of NA and EU locales.
 */
export const IPP_SUPPORTED_LOCALES = [...IPP_NA_LOCALES, ...IPP_EU_LOCALES] as const
